import { contentApi, availabilityApi, zimbaApi, webappsApi } from '@/infrastructure/Configuration'
import { isTaxIncludedRegion } from '@/infrastructure/Utils'

export default class DestinationService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async getHotels(hotelCodes) {
    const url = `${zimbaApi}/hotels?` + hotelCodes.map(code => 'code=' + code).join('&')
    try {
      const { data } = await this.httpClient.get(url)
      return data.hotels
    } catch (e) {
      console.error('Unable to retrieve hotels: ', e)
    }
  }

  async getBrands() {
    const url = `${contentApi}/hotels/brands`
    const response = await this.httpClient.get(url)

    return response.data.brands
  }

  async getHotel(hotelCode, externalGroup) {
    const url = `${contentApi}/hotels/${hotelCode}`
    try {
      const response = await this.httpClient.get(url, { params: { externalGroup } })
      return response.data.hotel
    } catch (error) {
      return undefined
    }
  }

  async getBenefits(bookingType, externalGroup) {
    const url = `${contentApi}/rewards/tier/benefits/extended`
    try {
      const response = await this.httpClient.get(url, {
        params: { bookingType, externalGroup }
      })
      return response.data
    } catch (error) {
      return undefined
    }
  }

  async getFromPrice(hotelCode) {
    const params = {
      hotelCodes: hotelCode,
      futureDays: 60,
      sourceOfBusiness: global.device.desktop() ? 'desktop' : 'mobile'
    }
    const url = `${availabilityApi}/multiple-price-from`
    const response = await this.httpClient.get(url, { params })

    return response.data.priceFrom
  }

  async getMultiplePriceFrom(_params) {
    if (!_params?.hotelCodes) {
      return
    }

    const params = {
      hotelCodes: _params.hotelCodes,
      taxIncludedRegion: isTaxIncludedRegion() ? isTaxIncludedRegion() : '',
      sourceOfBusiness: global.device.desktop() ? 'desktop' : 'mobile'
    }

    if (_params.startDate) {
      params.startDate = _params.startDate
    }

    if (_params.endDate) {
      params.endDate = _params.endDate
    }

    if (_params.searchType) {
      params.searchType = _params.searchType
    }

    if (_params.promotionCode) {
      params.promotionCode = _params.promotionCode
    }

    if (_params.memberOnlyRatesHotelCodes && _params.memberOnlyRatesHotelCodes.length) {
      params.memberOnlyRatesHotelCodes = _params.memberOnlyRatesHotelCodes
    }

    if (_params.futureDays) {
      params.futureDays = _params.futureDays
    }

    if (_params.origin) {
      params.origin = _params.origin
    }

    if (_params.adults) {
      params.adults = _params.adults
    } else {
      params.adults = 2
    }

    if (_params.memberType) {
      params.memberType = _params.memberType
    }

    const queryParams = global.Utils.stringifyQueryParams(params)

    const url = `${availabilityApi}/multiple-price-from?${queryParams}`
    let response
    try {
      response = await this.httpClient.get(url, {
        headers: {
          'x-currency': window.Cookie.read(window.cookieDictionary.preferredCurrency)
        }
      })
    } catch (error) {
      console.error(error)
    }
    return response?.data || {}
  }

  async getCoBrandsImage(coBrandKeys) {
    const params = {
      coBrandKeys: coBrandKeys.join(',')
    }
    const url = `${contentApi}/hotels/cobrands/images`
    const response = await this.httpClient.get(url, { params })
    const images = response.data.images
    const coBrands = {}
    images.forEach(item => {
      coBrands[item.coBrand] = item
    })
    return coBrands
  }

  async getModelFourHotels() {
    const url = `${webappsApi}/rewards/model-four-hotels`
    const { data } = await this.httpClient.get(url)
    return data.hotelCodes || data || {}
  }
}
